// Navigation utility using React Router history instead of window.location
let navigate: any = null

// Set navigate function from React Router
export const setNavigate = (navigateFunction: any) => {
  navigate = navigateFunction
}

// Simple navigation utility
export const navigateTo = (screen: "home" | "cart" | "checkout" | "success" | "error" | "no-internet") => {
  // Use React Router navigation if available, otherwise fallback to window.location
  if (navigate) {
    let path: string
    if (screen === "home") {
      path = "/"
    } else if (screen === "success") {
      path = "/order-success"
    } else {
      path = `/${screen}`
    }
    
    // Get current URL parameters to preserve them
    const urlParams = new URLSearchParams(window.location.search).toString()
    const fullPath = urlParams ? `${path}?${urlParams}` : path
    
    navigate(fullPath)
  } else {
    // Fallback to window.location
    const urlParams = new URLSearchParams(window.location.search).toString()
    
    let path: string
    if (screen === "home") {
      path = "/"
    } else if (screen === "success") {
      path = "/order-success"
    } else {
      path = `/${screen}`
    }
    
    const fullPath = urlParams ? `${path}?${urlParams}` : path
    window.location.href = fullPath
  }
}

// Check if required QR parameters are present
export const hasRequiredParams = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search)
  const branchId = urlParams.get('branchId')
  const typeId = urlParams.get('typeId')
  return !!(branchId && typeId)
}
